import { useMemo } from 'react'

import { FormContent } from './components/Form/Form'
import { Footer } from './components/Form/components/Footer'
import { form } from './formState'
import { useFormInitialValue } from './hooks/useFormInitialValue'
import { useHideTrafficAreasWhileEditing } from './hooks/useHideTrafficAreasWhileEditing'
import { useOnSubmit } from './hooks/useOnSubmit'
import { useTexts } from './hooks/useTexts'

interface Props {
  trafficProfile: uui.domain.client.rm.TrafficProfile
  creating?: boolean
}

export function SingleEdit(props: Props) {
  const { trafficProfile, creating } = props

  const initialValues = useFormInitialValue(trafficProfile, creating)
  const onSubmit = useOnSubmit(trafficProfile)
  const texts = useTexts()

  useHideTrafficAreasWhileEditing()

  const config = useMemo(
    () => ({
      id: 'traffic-area-form',
      initialValues,
    }),
    [initialValues],
  )

  return (
    <form.Form
      config={config}
      title={texts.edit}
      onSubmit={onSubmit}
      footer={<Footer />}
      requireTransaction
      stopEditingOnUnmount
      applyPendingFitMapOnMount
    >
      <FormContent initialValues={initialValues} />
    </form.Form>
  )
}
